import { addModal } from 'weblite-web-modal-viewer'
import { LoadingModal } from './loading-modal'
import { t } from '$i18n'

const COMPONENT_ID = 'loadingModal'

const showLoadingModal = (text: string) =>
  addModal({ id: COMPONENT_ID, props: { text } })

export const showLoadingMessagesModal = () =>
  showLoadingModal(t('loadingModal.messages'))

export const showSaveChangesLoadingModal = () =>
  showLoadingModal(t('loadingModal.saveChanges'))

export const showLoadFromServerLoadingModal = () =>
  showLoadingModal(t('loadingModal.loadFromServer'))

export const showProcessingMessageLoadingModal = () =>
  showLoadingModal(t('loadingModal.processingMessage'))

export const showSharedMediaLoadingModal = () =>
  showLoadingModal(t('loadingModal.sharedMedia'))

export const showWappOverlayLoadingModal = () =>
  showLoadingModal(t('loadingModal.wappOverlay'))

export default {
  [COMPONENT_ID]: {
    Component: LoadingModal,
  },
}
